import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Sorting",
  "use": "icon-Sorting-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-Sorting\"><path d=\"M980.59584599 326.1622409l-417.34317531 468.595846c-28.0669387 31.72784372-76.87900598 31.72784372-103.72564303 0L42.1838523 326.1622409C1.9138968 281.01107865 33.64174052 209.01327941 94.65682465 209.01327941l834.6863507 0C989.13795778 209.01327941 1022.0861032 281.01107865 980.59584599 326.1622409z\" p-id=\"14895\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol